import { alpha, darken, styled } from '@mui/material/styles';
import { Tab } from '@mui/material';

const StyledTab = styled(Tab)(({ theme }) => ({
    textTransform: 'none',
    minHeight: 'auto',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    fontWeight: 400,
    padding: theme.spacing(1, 2),
    backgroundColor: 'inherit',

    '&.Mui-selected': {
        fontWeight: 600,
        backgroundColor: theme.palette.common.white,
    },

    '&.MuiTab-root': {
        fontSize: '0.875rem',
        lineHeight: 1.43,
        color: theme.palette.text.primary,
    },
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.4),
    },
}));

export default StyledTab;
